import { render } from "./MessagesInformation.vue?vue&type=template&id=6349a680&scoped=true"
import script from "./MessagesInformation.vue?vue&type=script&lang=js"
export * from "./MessagesInformation.vue?vue&type=script&lang=js"

import "./MessagesInformation.vue?vue&type=style&index=0&id=6349a680&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6349a680"]])

export default __exports__